module.exports = __webpack_public_path__ + "media/application/images/ui/icon-search-ad41c8dab4f85f3b91a4527557dd3a61.png";